import { BUTLER_TAB, type ButlerTabType } from '@cart-services/constants/butler-tab'

interface AiRecognitionInputProps {
  selectedTab: ButlerTabType
  csvFile: File | undefined
  pdfFile: File | undefined
  customerId: string | number | undefined
}

// PDF 建單要帶 customerId，會員資料還沒回來就送出會直接進錯誤頁
export const canSubmitAiRecognition = ({ selectedTab, csvFile, pdfFile, customerId }: AiRecognitionInputProps): boolean => {
  const hasInputByTab: Record<ButlerTabType, boolean> = {
    [BUTLER_TAB.CSV]: !!csvFile,
    [BUTLER_TAB.FILE]: !!customerId && !!pdfFile,
    [BUTLER_TAB.PHOTO]: false,
  }
  return hasInputByTab[selectedTab]
}
